module.exports = "<ng-container *ngIf=\"content | async as row\">\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-sm-12 header\">\n                <h2>View Videos</h2>\n            </div>\n        </div>\n        <div class=\"row\" *ngIf=\"row.data\">\n            <media-cell *ngFor=\"let video of row.data\" [item]=\"video\">\n            </media-cell>\n        </div>\n    </div>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/video-row/video-row.template.html
// module id = 738
// module chunks = 2